import { NavbarSkin } from './skins/navbar.ts';
import { navigateTo } from "../framework/router.ts";
import Utils from "../framework/utils.ts"; // adjust path as needed
import { authContext } from "../context/AuthContext.ts";

export default function MainNavbar() {
  // Use a <template> to safely parse HTML
  const template = document.createElement('template');
  let navbarskin = new NavbarSkin().navbarhtml();
  template.innerHTML = navbarskin.trim();
  const fragment = template.content;

  const navContainer = fragment.querySelector('.navbar');

  // Show/hide based on authentication & role
  function updateAuthUI() {
    const isLoggedIn = !!authContext.user;
    const role = authContext.user?.isSuperAdmin || null;

    // Superadmin-only links
    navContainer.querySelectorAll('.superadmin-only').forEach(el => {
      el.style.display = (isLoggedIn && role === true) ? '' : 'none';
    });

    // User dropdown
    const userDropdown = navContainer.querySelector('#userDropdown');
    const logoutBtn = navContainer.querySelector('#logout');
    if (isLoggedIn) {
      if (authContext.user?.username) {
        userDropdown.textContent = `${authContext.user.username} ▼`;
      }
      userDropdown.style.display = '';
      logoutBtn?.parentElement?.style.setProperty('display', '');
    } else {
      userDropdown.style.display = 'none';
      logoutBtn?.parentElement?.style.setProperty('display', 'none');
    }
  }

  // Highlight active link based on current path
  function highlightActiveRoute(path = window.location.pathname) {
    navContainer.querySelectorAll('[data-path]').forEach(el => {
      el.classList.toggle(
        'active',
        path === el.dataset.path || path.startsWith(el.dataset.path + '/')
      );
    });
  }

  // Bind click events
  navContainer.querySelectorAll('[data-path]').forEach(el => {
    el.addEventListener('click', e => {
      e.preventDefault();
      const path = el.dataset.path;
      navigateTo(path);
      highlightActiveRoute(path);
    });
  });

    const dropdownMenu = navContainer.querySelector('.dropdown-menu');
    const userDropdownBtn = navContainer.querySelector('#userDropdown');

    userDropdownBtn?.addEventListener('click', () => {
      dropdownMenu.classList.toggle('show');
    });

    // Optional: hide dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!userDropdownBtn.contains(e.target) && !dropdownMenu.contains(e.target)) {
        dropdownMenu.classList.remove('show');
      }
    });

  // Logout
  navContainer.querySelector('#logout')?.addEventListener('click', () => {
    authContext.logout();
    navigateTo('/login');
    highlightActiveRoute('/login');
    updateAuthUI();
  });

  // theme toggle
  const themeToggle = navContainer.querySelector('#themeToggle');
  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      const currentTheme = Utils.getCurrentTheme();
      const newTheme = currentTheme === 'light' ? 'dark' : 'light';
      Utils.setTheme(newTheme);
      themeToggle.innerHTML =
        newTheme === 'light'
          ? '<span class="iconify" data-icon="si:toggle-off-fill" data-inline="false"></span>'
          : '<span class="iconify" data-icon="ri:toggle-line" data-inline="false"></span>';
      // After setting new theme:
      window.dispatchEvent(new CustomEvent('themechange', { detail: { theme: newTheme } }));

    });

    // Set initial icon
    const initialTheme = Utils.getCurrentTheme();
    themeToggle.innerHTML =
      initialTheme === 'light'
        ? '<span class="iconify" data-icon="si:toggle-off-fill" data-inline="false"></span>'
        : '<span class="iconify" data-icon="ri:toggle-line" data-inline="false"></span>';
  }

  // Initial UI setup
  highlightActiveRoute();
  updateAuthUI();

  // Listen to browser navigation
  window.addEventListener('popstate', () => highlightActiveRoute());

  return fragment;
}
